import { Controller } from "@hotwired/stimulus"

// Deactivate/activate marketplace item
// Values: slug
// Targets: container
export default class extends Controller {
  static values = { slug: String }
  static targets = ["container"]

  connect() {
    this.open = false
    this.sent = false
  }

  showForm(event) {
    event.preventDefault()

    if (this.open) {
      this.open = false
    } else {
      this.open = true
    }
    this.render()
  }

  deactivate(event) {
    event.preventDefault()
    const textarea = this.containerTarget.querySelector("textarea")
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/marketplace/items/" + this.slugValue + "/toggle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ msg: textarea ? textarea.value : "" })
    }).then(response => {
      if (response.ok) {
        this.open = false
        this.sent = true
        this.render()
        location.reload()
      }
    })
  }

  render() {
    if (this.sent) {
      this.containerTarget.innerHTML = ""
      return
    }

    if (this.open) {
      this.containerTarget.innerHTML = `<form novalidate data-action="submit->item-deactivate#deactivate" class="input-group mt-4">
        <label class="input-label" for="msg">Reason for deactivation</label>
        <textarea class="input-text" name="msg" placeholder="Did you sell it on permapeople marketplace?"></textarea>
        <div class="text-right pt-4">
          <input type="submit" class="btn-primary" value="Deactivate" />
        </div>
      </form>`
    } else {
      this.containerTarget.innerHTML = `<a class="btn-secondary-danger" data-action="click->item-deactivate#showForm" href="/marketplace/items/${this.slugValue}/toggle">Deactivate</a>`
    }
  }
}
